<template>
  <v-card>
    <v-toolbar flat color="white" density="compact">
      <v-autocomplete
          class="reg-normal text-primary"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-model="selected_category"
          :return-object="false"
          :items="categories"
          hide-details
          single-line
          disabled>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('category') }}</span>
        </template>
      </v-autocomplete>
      <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          :label="$store.getters.translate('subcategory')"
          v-model="selected_subcategory"
          :return-object="false"
          :items="subcategories[selected_category]"
          hide-details
          single-line>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('subcategory') }}</span>
        </template>
      </v-autocomplete>
    </v-toolbar>
    <v-data-table
        id="base_table_project_management_answers"
        :headers="headers"
        :items="getRecords"
        class="elevation-1"
        show-select
        :items-per-page="100">
      <template #header.data-table-select>
        <v-chip variant="outlined" class="bulk-chip" rounded="pill" size="large" density="comfortable">
          <v-menu :disabled="selected.length === 0">
            <template #activator="{ props: menuProps, isActive }">
              <div class="chip-content">
                <v-checkbox
                    :model-value="selected.length > 0 && selected.length === getRecords.length"
                    :indeterminate="selected.length > 0 && selected.length < getRecords.length"
                    @click="toggleSelectAll"
                    color="success"
                    hide-details/>
                <v-btn v-bind="menuProps" v-if="selected.length" icon class="arrow-btn" elevation="0">
                  <PhCaretUp v-if="isActive" size="20"/>
                  <PhCaretDown v-else size="20"/>
                </v-btn>
              </div>
            </template>
            <v-list v-if="selected.length > 0">
              <!--DELETE-->
              <v-list-item @click.stop="bulkArchive">
                <template #prepend><PhTrash size="24"/></template>
                <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate("delete") }} {{ selected.length }} {{ $store.getters.translate(page.name) }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-chip>
      </template>
      <template #body="{ items }">
        <draggable :list="items" tag="tbody" @end="endDrag(items)" item-key="id">
          <template #item="{ element:answer }">
            <tr class="sm-normal text-primary">
              <td><v-checkbox v-model="selected" :value="answer" hide-details color="success" density="compact"/></td>
              <td><PhArrowsVertical size="20" weight="bold" style="cursor: pointer; vertical-align: middle;"/></td>
              <td>{{ answer.sort_order }}</td>
              <td><a class="sm-bold" @click="editAnswer(answer)">{{ answer.name }}</a></td>
              <td>{{ answer.category }}</td>
              <td>{{ answer.subcategory }}</td>
              <!--ACTION BUTTONS-->
              <td style="text-align: center; width: 80px;">
                <v-menu>
                  <template #activator="{ props }">
                    <v-btn elevation="0" icon v-bind="props">
                      <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="editAnswer(answer)">
                      <template #prepend><PhPencilSimpleLine size="24"/></template>
                      <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('edit') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deleteRecord(answer.id)">
                      <template #prepend><PhTrash size="24"/></template>
                      <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('delete') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </draggable>
      </template>
      <template #bottom/>
    </v-data-table>
  </v-card>
  <base-edit-dialog modal_name="edit_answer" ref="edit_answer" :page="page" :internal_model="true" @refresh="$emit('refresh')"/>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions.js";
import draggable from "vuedraggable";
import BaseEditDialog from "./BaseEditDialog";
import { PhArrowsVertical, PhDotsThreeVertical, PhPencilSimpleLine, PhTrash, PhCaretUp, PhCaretDown } from "@phosphor-icons/vue";
import { useAbility } from '@casl/vue';

export default {
  components: { BaseEditDialog, draggable, PhArrowsVertical, PhTrash, PhPencilSimpleLine, PhDotsThreeVertical, PhCaretUp, PhCaretDown },
  setup() {
    const { can } = useAbility()
    return { can }
  },
  props: ["current_tab", "answers"],
  data() {
    return {
      page: helpFunctions.pages.projectmanagementanswers,
      records: [],
      selected: [],
      headers: [],
      categories: helpFunctions.getProjectManagementAnswerCategories(),
      subcategories: helpFunctions.getProjectManagementAnswerSubcategories(),
      selected_category: null,
      selected_subcategory: null,
    };
  },
  beforeMount() {
    document.querySelector('#base_table_project_management_answers > .v-table__wrapper > table > tbody')?.remove();
  },
  mounted() {
    const sortableTbody = document.querySelector('#base_table_project_management_answers > .v-table__wrapper > table > tbody > tbody');
    // <draggable> ruin view in <tbody> (create a <div> tag inside <tbody>)
    //FIX: https://github.com/SortableJS/Vue.Draggable/issues/1212#issuecomment-1918880591
    if (sortableTbody) {
      const tbody = document.querySelector('#base_table_project_management_answers > .v-table__wrapper > table > tbody')
      tbody.parentNode.append(sortableTbody);
      tbody.remove()
    }
  },
  created() {
    this.headers = helpFunctions.composeTableHeaders(helpFunctions.headers.project_management_questions_and_answers);
    this.selected_category = this.current_tab;
    this.selected_subcategory = this.subcategories[this.selected_category][0];
  },
  methods: {
    showRecords() {
      this.records = [];
      for (let i = 0; i < this.answers.length; i++) {
        if (this.answers[i].category.toLowerCase() === this.selected_category.toLowerCase() &&
            this.answers[i].subcategory.toLowerCase() === this.selected_subcategory.toLowerCase()) {
          this.records.push(this.answers[i]);
        }
      }
    },
    save() {
      for (let i = 0; i < this.records.length; i++) {
        helpFunctions.saveModelSilently(this.page.name, this.records[i]);
      }
      this.$toast.success(this.$store.getters.translate("successfully_saved"));
    },
    endDrag(items) {
      let temp_records = this.records;
      for (let i = 0; i < temp_records.length; i++) {
        for (let z = 0; z < items.length; z++) {
          if (temp_records[i].id === items[z].id && temp_records[i].sort_order !== z + 1) {
            this.records[i].sort_order = z + 1;
          }
        }
      }
      this.records.sort((a, b) => a.sort_order - b.sort_order); // The table was not re-sorted in the previous algorithm, although the values were changed correctly.
    },
    editAnswer(answer) {
      this.$refs.edit_answer.load(answer.id);
    },
    async deleteRecord(id) {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteModel(this.$toast, this.page.name, id);
          this.$emit('refresh');
        }
      });
    },
    toggleSelectAll() {
      const currentValues = this.records;
      const allSelected = currentValues.every(cv =>
          this.selected.some(sel => sel.id === cv.id)
      );
      if (allSelected) {
        this.selected = this.selected.filter(item =>
            !currentValues.some(cv => cv.id === item.id)
        );
      }
      else {
        const selectedIds = new Set(this.selected.map(item => item.id));
        console.log(currentValues)
        const toAdd = currentValues.filter(cv => !selectedIds.has(cv.id));
        this.selected = [...this.selected, ...toAdd];
      }
    },
    async bulkArchive() {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.postCustomRoute(this.$toast, "bulk/remove", { model: this.page.model, ids: this.$lodash.map(this.selected, "id") }, true, true);
          this.selected = [];
          this.$emit('refresh');
        }
      });
    },
  },
  computed: {
    getRecords() {
      if(this.records) {
        return this.records;
      }
      else {
        return [];
      }
    },
  },
  watch: {
    selected_subcategory: {
      handler() {
        this.showRecords();
      },
    },
    answers: {
      handler() {
        this.showRecords();
      },
    },
  },
};
</script>

<style scoped>
.v-checkbox {
  display: flex;
}
.v-text-field >>> input {
  font-size: 12px !important;
}
.v-text-field >>> label {
  font-size: 12px !important;
}
.bulk-chip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-color: rgba(var(--v-theme-primary), 0.3);
  padding: 0px !important;
}
.chip-content {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}
.arrow-btn {
  width: 36px;
  height: 36px;
  min-width: 0;
  background-color: transparent;
}
</style>